import { useEffect, useRef, useState } from 'react';

/**
 * Render a string with a typewriter effect.
 * - text: the target text
 * - speed: ms per character (default 8 → ~125 chars/sec — ChatGPT-ish)
 * - active: when false, render text instantly (used for cached responses)
 */
export default function Typewriter({ text, speed = 8, active = true, className }) {
  const [shown, setShown] = useState(active ? '' : text || '');
  const idxRef = useRef(0);

  useEffect(() => {
    idxRef.current = 0;
    if (!active || !text) {
      setShown(text || '');
      return undefined;
    }
    setShown('');
    const id = setInterval(() => {
      idxRef.current += 2; // 2 chars per tick for snappier feel
      if (idxRef.current >= text.length) {
        setShown(text);
        clearInterval(id);
      } else {
        setShown(text.slice(0, idxRef.current));
      }
    }, speed);
    return () => clearInterval(id);
  }, [text, speed, active]);

  return <span className={className}>{shown}{active && shown.length < (text || '').length && <span className="inline-block w-0.5 h-3 bg-current ml-0.5 align-middle animate-pulse" />}</span>;
}
